import React, { Component } from 'react'
import { connect } from 'react-redux'
import logo from '../../images/icons/ico_me_melia.svg'
import { CMSPath, DEVICEREGFORMENABLED, HEADER_LOCATION_AFTER_LOGIN, HEADER_LOCATION_REDIRECTS_TO_CORPS, WITH_MASTER_CONNECTOR } from '../../../config/constant'
import { setAdminLoginPage, setCurrentHomePage, setCurrentHomePageBeforeNotificationTab, setExternalSignIn, setGoHome, setLoader, setLoginRequired, setOpenExternalLinkInSameTab, showConfirmationPage } from '../../action/homeAction'
import { currentWidget, setFailScreen, setHotelSelectionAfterLoginState, setRegPage, setShowCustomPopup } from '../../../action/action'
import PropTypes from 'prop-types';
import $ from 'jquery';
import { scrollDownEffect,removeScrollDown } from '../roomControl2/scrollEffect';
import { guestJourneyNotification, sendAnalytics } from '../../../action/homeAction';
import { HashRouter, Link, Redirect, Router } from 'react-router-dom'
import HelpButton from '../../UI/helpButton'
import notificationIcon from "../header/assets/ico_notifications.svg"
import { notificationKeys } from '../../../config/layout2constant'
import { inAppBrowser } from '../../JS/inAppBrowser'
import { handleLocationSelect } from '../hotelSelector/hotelSelector'
import { getHotelListUpdatingProps } from '../../../action/hotelSelector'
import { closeOrderPopUp } from '../../action/hCommerce2'
import { getCdnUrl } from '../../../config/config'

class Header extends Component {
    constructor(props) {
        super(props);
        this.logoClickTimeOut = 0
        this.room = localStorage.getItem("room");
        this.state = {
            logoClickCount: 0,
            eventTouch: "click",
            touchY: 0,
            imageHeight: 200,
            autocheckinSelfie:null,
            showNotification: false,
            goToHotelSelect: false,
            renderConnectorBackButton: false,
            changeProfileImage: false,
            redirectDirectlyToCorps:false
        }
        this.headerHeight = null;
        this.startY = 0;
    }

     master_hotel_code = (process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
     current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
   

    logoClick = () => {

        if(WITH_MASTER_CONNECTOR){
            this.goToHotelSelect();
            this.setState({goToHotelSelect: true});
            return;
        }

        if(DEVICEREGFORMENABLED){

        window.clearTimeout(this.logoClickTimeOut);
        if (this.state.logoClickCount >= 5) {
            this.props.setAdminLoginPage(true);
        } else {
            this.setState({ logoClickCount: this.state.logoClickCount + 1 })
        }
        this.logoClickTimeOut = window.setTimeout(
            () => { this.setState({ logoClickCount: 0 }) }, 2000
        )}
    }

    profileClick = () => {
        // this.props.showConfirmationPage(true, "header","thanks for the message.");
        if(process.env.REACT_APP_INROOMTAB == "true"){
            this.props.setRegPage(true);
        } else {
            const room = localStorage.getItem('room');
            if(room && room != "null"){
                this.setState({changeProfileImage:true})
            }else{
                this.props.setRegPage(true);
            }
        }
    }
 
    refreshNotification = (height) => {

        console.log("refresh Notification callback")
        const sessionToken = localStorage.getItem('GuestJourneySessionToken');
        if(this.props.currentHomePage.label === "NOTIFICATIONS"){
            this.props.guestJourneyNotification(sessionToken);
        }
    }

    onNotificationClick = () => {

        this.props.setCurrentHomePageBeforeNotificationTab(this.props.currentHomePage);

        let foundNotification = false;
        this.props.footerTabList.map((item) => {
            if (notificationKeys.some(el => el === item.uniqueKey.toLowerCase()) || item.tabName.replace(/ /g,'').toLowerCase() === "notifications") {
                this.props.setCurrentHomePage(item);
                foundNotification = true;
            }
        })
        if(!foundNotification){
            this.props.setCurrentHomePage({
                tabName :  "Notifications",
                uniqueKey : "notifications"
            });
        }

        this.setState({showNotification: true});
    }

    goBack = () => {
        this.props.setCurrentHomePage(this.props.currentHomePageBeforeNotificationTab);
    }

    goToHotelSelect = () => {
        this.props.currentWidget({widgetType: "Hotel Selector"}) 
    }


    getNewNotCount = (notifications) => {
        if(!notifications || notifications == "null"){
            return 0;
        }

        let count = 0;

        for(let obj of notifications){
            if(obj.status === "NEW"){
                count = count + 1;
            }
        }

        return count;
    }

    handleRedirectToCorps = async () => {

        if(!this.props.location_data.payload){
            this.props.setLoader(true, "Loading...", true)
            await this.fetchHotelList();
            this.props.setLoader(false);
        }
        
        let data = this.props.location_data.payload;
        let corporateHotelData;
    
        if (data && data.length > 0) {
            for (const hotelRegion of data) {
                if (hotelRegion.hotelList && hotelRegion.hotelList.length > 0) {
                    for (const hotelData of hotelRegion.hotelList) {
                        if (hotelData.hotelPropertyKey == this.master_hotel_code) {
                            corporateHotelData = hotelData;                    
                        }
                    }
                }
            }
        }
        
        handleLocationSelect(this.props, corporateHotelData, false, (status) => {
            if (!status) {
                this.props.setGoHome(true)
            }
        })
    }

    fetchHotelList =()=>{
        this.props.getHotelListUpdatingProps();
    }

    componentDidUpdate() {
        if(this.state.showNotification && window.location.hash != '#/notifications'){
            this.setState({showNotification: false});
        }
    }

    componentWillUnmount(){
        try {
            removeScrollDown();    
        } catch (error) {
            console.log(error);
        }
        
    }

    componentDidMount(){
        const room = localStorage.getItem('room');

        const master_hotel_code = (process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        // this.headerForTamassa()

        if(WITH_MASTER_CONNECTOR && (master_hotel_code != current_hotel_code)){

            if(HEADER_LOCATION_REDIRECTS_TO_CORPS && ( this.props.location_data.status != "SUCCESS" || this.props.location_data.payload )){
                this.fetchHotelList();
                this.setState({redirectDirectlyToCorps:true})
            }
            

            if((room && room != "null") || (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))){
                if(HEADER_LOCATION_AFTER_LOGIN) this.setState({ renderConnectorBackButton: true });
                return;
            }
            
            this.setState({ renderConnectorBackButton: true })
        }

        console.log('this.props.showNewHeader',this.props.showNewHeader);

        const platform = window.device ? window.device.platform : ''; 

        // console.log("header local storage room",room);
        if(room && room != "null"){

            if(platform == 'Android'){
                const profile_img = localStorage.getItem('profile_photo');
                    if(profile_img && profile_img != 'null'){
                        this.setState({autocheckinSelfie:profile_img});
                    }
            } else {
                setTimeout(() => {
                    const profile_img = localStorage.getItem('profile_photo');
                    if(profile_img && profile_img != 'null'){
                        // alert(`using profile_img: ${profile_img}`);
                        this.setState({autocheckinSelfie:profile_img});
                    }
                }, 1000);
            }
            
        }
    } 


    render() {
        let profileImage = `${CMSPath}${this.props.profile.profileImageUrl}`
        scrollDownEffect("app-body","header",this.props.menuColor,13,this.refreshNotification);
       


        return (
            <header
            id = "header" className={this.props.header_class ? this.props.header_class : ""}
            style={ this.props.showBackgroundImage && this.props.bgImage ? { backgroundImage: `url(${CMSPath}${this.props.bgImage})`, 
            backgroundPosition:"center", position:"sticky", backgroundSize: "cover" } : {}}
            >
            <HashRouter>
            <>
                <HelpButton openLaunchGuide={() => this.props.openLaunchGuide()} />

                {
                    this.props.isNotficationTab ? <Link to="/" onClick={this.goBack} className="button-back"></Link>
                    : this.state.renderConnectorBackButton && 
                    ( this.state.redirectDirectlyToCorps ? <div onClick={this.handleRedirectToCorps} class="button-back locations"></div> 
                                                         : <Link onClick={this.goToHotelSelect} to="/selectHotel" class="button-back locations"></Link>)
                }

                <div class="hotel-name" id = "hotel_logo" style = {{transition:"0.2s"}}
                //  onClick={this.logoClick}
                 >
                    {/* <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" width="200" height="129.48" viewBox="0 0 200 129.48"><defs></defs><title>logo_MeDubai</title><text class="cls-1" transform="translate(70.46 110.23)">DUBAI</text><path class="cls-2" d="M92.93,74.68a20.56,20.56,0,0,1-1.14-2.47c-.76-2.26,0-5.07-.49-7.42a53.33,53.33,0,0,1-.48-14.17c.28-4.1,1.5-9.1,1.7-13.48.26-5.59,2.93-16,1.21-18.5-.74-1.18-3.64-2.36-5-1.4s-2.25.44-3.16,2.07a60.63,60.63,0,0,0-3.92,7.81c-1.48,3.85-7,7.09-9.51,10.32-.36.46-.72.93-1.1,1.37-2.12,2.47-5.4,5.63-8.81,5.91-3.79.32-5.3-3.08-6.37-6.1C54.3,34.3,52.92,30,52.77,25.39c-.11-3.4.23-6.54-1.39-9.75a4.84,4.84,0,0,1-.53-1.07c-5.14.1-11.68,4.17-12.64,9.1-.35,1.9.58,4,.63,5.87.15,6.65.42,13.19.76,19.83.19,3.65-.08,7.31,0,11,.07,4.22-.13,9.17,1.71,13.09,2.86,6.08,13.16-1.18,10.31-5.31C51.06,66.72,49.45,67,48.7,66c-3.89-5.09-.81-11.85-1.43-17.51-.08-.76-.23-1.91.37-2.51.1-.11.1-.22.21-.32.75,1.38,2.25,3.74,3.75,4.28,3.1,2,7.6-1,9.63-1.82C63.7,47,66,47,68,45.63c5.14-3.43,13.55-7.82,16.65-13.07h.86a114.27,114.27,0,0,1-1.88,18.9A48,48,0,0,0,84.35,72a9.38,9.38,0,0,0,2.33,4.18,14.6,14.6,0,0,0,1.84,1.58c.48.36,1,.71,1.44,1.07,1,.77,1.86,1.78,3.26,1.54s1.59-.76,1.23-2A22,22,0,0,0,92.93,74.68Z"/><path class="cls-2" d="M161.85,64.35a198,198,0,0,0-20.18,2.57q-2.56.47-5.1,1c-4.51.94-12.34,2.14-16.91,2.76-.22,0-.42-5-.42-5.53a28.78,28.78,0,0,1-.1-5.18,10.1,10.1,0,0,1,1.74-1.39l1.77-1c1.2-.73,2.39-1.48,3.63-2.14,2.49-1.32,5.34-2.69,7.75-4.16,3.62-2.19,7.31-5.18,7.73-10.68a3.23,3.23,0,0,0,0-1,5.47,5.47,0,0,0-.67-1.2c-.95-1.48-2.91-1.92-4.67-2A24.89,24.89,0,0,0,121.57,40c-.65.41-1.59.82-2.08.22a1.57,1.57,0,0,1-.22-1q.14-5.92.54-11.83a2.54,2.54,0,0,1,.37-1.39,2.46,2.46,0,0,1,.8-.62,25.74,25.74,0,0,1,21.28-1.66c-.16,1.16.09,2.82,1.26,2.81a2,2,0,0,0,1.24-.67c1.5-1.43,2.76-3.47,2.23-5.46a4.69,4.69,0,0,0-2.76-2.92,11,11,0,0,0-4.07-.69,34.9,34.9,0,0,0-19.42,5.42,42.66,42.66,0,0,0-.06-5.54c-.13-1-.46-.79-1.41-.57a8.34,8.34,0,0,0-2,.75,9.22,9.22,0,0,0-4,4,9.5,9.5,0,0,0-.91,2.74c-.18,1.05-.53,2.08-.65,3.13s-3.17,1.16-3,2.14a2.56,2.56,0,0,0,2.72,1.4c0,3.18-.17,6.35-.44,9.52a2,2,0,0,1-.25,1,2.38,2.38,0,0,1-1.15.77,12.84,12.84,0,0,0-3.47,2.2A8.41,8.41,0,0,0,103.52,47c-.88,3.1,5.94,1.93,7.42,1.71-.16,4.82,0,8.4.22,12.18-.36.28-.71.52-.83.63-2.42,2-5.45,2.83-6.67,5.9s-.4,5.66,1.79,6.58c2.67,1.13,4.52,3.21,7.58,3.51a14.51,14.51,0,0,0,3.21-.22c.43,0,.87-.07,1.3-.13,12.37-1.61,28.82-7.55,41.77-10.55C160.53,66.32,162.07,65.59,161.85,64.35ZM119,50.07c.06-1.84.08-3.83,1.33-5.32,1.45-1.73,3.83-2.3,6-2.73a12.31,12.31,0,0,1,4.79-.24,4.4,4.4,0,0,1,3.47,3,4,4,0,0,1,.08.48c.41,2.89-1.87,5-4.12,6.36a71.94,71.94,0,0,1-7.14,3.56c-.69.32-1.35.71-2,1s-1.37.6-2,1l-.12.07a2,2,0,0,0-.3.21C119.06,57.16,119,52.11,119,50.07Zm-9.49,20a3.78,3.78,0,0,1,.28-2.76A6.81,6.81,0,0,1,111.36,65c.07,1.59.12,3.28.14,5.17,0,.33,0,.78,0,1.29C111.45,71.41,109.93,72.05,109.55,70Z"/></svg> */}
                    <img  src={getCdnUrl(CMSPath, this.props.logo)} />
                </div>
                {!this.props.hideProfilePhoto && <div id = "guest_photo" class={`guest-photo ${this.room && this.room !== "null" ? "logged-in" : ""}`} onClick={this.profileClick}
                    style={{
                        backgroundImage: this.state.autocheckinSelfie && this.state.autocheckinSelfie != "null" ? `url(${this.state.autocheckinSelfie})` : `url('${profileImage}')`,
                        backgroundPosition: 'center',
                        backgroundSize: "cover",
                        backgroundRepeat:"no-repeat",
                        transition:"0.2s"
                    }}>
                       {this.room && this.room !== "null" && <p className='profileRoomHidden'>{this.room}</p>}
                    {/* <img src={profileImage} /> */}
                </div>}

                {   !this.props.isNotficationTab &&
                    <div id = "profile_notification" class={`profile_notification ${this.room && this.room !== "null" ? "logged-in" : ""}`} onClick={this.onNotificationClick} 
                    style={{
                        backgroundImage: `url('${notificationIcon}')`,
                        backgroundPosition: 'center',
                        backgroundSize: "cover",
                        backgroundRepeat:"no-repeat",
                        transition:"0.2s"
                    }}>
                    { 
                        this.getNewNotCount(this.props.notifications)>0 ? <div class="alert unread">
                            {this.getNewNotCount(this.props.notifications)}
                        </div>
                        
                        :this.props.notifications && this.props.notifications.length > 0 ? <div class="alert ">
                            {this.props.notifications.length}
                        </div>

                        : null
                    
                    }
                    </div>}

                    {/* { process.env.REACT_APP_EXTERNAL_SIGN_IN =="true" && (this.master_hotel_code != this.current_hotel_code) && this.props.externalSignIn && !this.props.externalSignIn.memberId && 
                        <div class="header-sign-in" 
                            style={{position: "absolute"}} >
                                <Link exact to="/theKnow">
                                     Sign in
                                </Link>
                        </div>
                    } */}
            </>
            </HashRouter>
                {
                    this.state.showNotification ? 
                    <HashRouter>
                        <Redirect exact to = "/notifications"/>
                    </HashRouter> : null
                }

                {
                    this.state.goToHotelSelect ?
                    <HashRouter>
                        <Redirect exact to = "/selectHotel"/>
                    </HashRouter> : null
                }

                {this.state.changeProfileImage ?  <HashRouter>
                    <Redirect exact to = "/change_profile_photo"/>
                </HashRouter> : null}
            </header>
        )
    }
}

Header.propTypes = {
    PageNameFromParent: PropTypes.string,
    GreetingFromParent: PropTypes.string
}

Header.defaultProps = {
    PageNameFromParent: "",
    GreetingFromParent: ""
}


const mapStateToProps = state => {
    return {
        selectedHomePage: state.store2.currentHomePage,
        showNewHeader: state.store2.showNewHeader,
        externalSignIn: state.store2.externalSignIn,
        widgetList: state.store2.sideNavBar.widgetList,
        footerTabList: getTabs(state.store.home.currentDuration),
        notifications: state.store.home.gJnotifications,
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        guestName: state.store.home.guestDetails ?
            state.store.home.guestDetails.guestName : null,
        selfieVideo: state.store2.selfieVideo,
        menuColor: state.store.home.MenuColor,
        currentHomePageBeforeNotificationTab: state.store2.currentHomePageBeforeNotificationTab,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        location_data: state.store2.location_data,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        
    }
}
const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}

export default connect(
    mapStateToProps,
    {
        setAdminLoginPage,
        showConfirmationPage,
        setRegPage,
        setOpenExternalLinkInSameTab,
        sendAnalytics,
        setLoginRequired,
        currentWidget,
        setCurrentHomePageBeforeNotificationTab,
        setCurrentHomePage,
        guestJourneyNotification,
        setShowCustomPopup,
        setExternalSignIn,
        setLoader, 
        setFailScreen, 
        setHotelSelectionAfterLoginState,
        getHotelListUpdatingProps,
        setGoHome,
        closeOrderPopUp, 
    }
)(Header);

//profileImageUrl